const Description = ({ description }) => {
  return (
    <p className="text-md font-[700] text-[#A1A1A1] mb-0 text-[20px]">
      {description}
    </p>
  );
}

export default Description;